<template>
  <v-badge
    bordered
    overlap
    color="red"
    :content="commentCount()"
    :value="commentCount()"
  >
    <v-icon x-large @click="changeCommentStatus(), selectItem()">
      mdi-message-outline
    </v-icon>
  </v-badge>
</template>

<script>
export default {
  name: 'ToReviewStatusButton',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      itemComments: this.item.itemComments
    }
  },
  mounted: function () {
    this.onDisplay()

    const subscribeMutationTypes = ['PostEditor/ADD_NEW_ITEM_COMMENT']
    this.$store.subscribe((mutation, state) => {
      if (subscribeMutationTypes.includes(mutation.type)) {
        if (mutation.payload.itemUuid === this.item.uuid) {
          this.postedCommentAction(state)
        }
      }
    })
  },
  methods: {
    commentCount: function () {
      return this.commentExist() ? this.itemComments.length : 0
    },
    commentExist: function () {
      return Array.isArray(this.itemComments)
    },
    onDisplay () {
      this.$emit('on-display', this.commentExist())
    },
    changeCommentStatus: function () {
      this.$store.commit('PostEditor/SET_TOOL_BAR_STATUS', 'comment')
    },
    selectItem: function () {
      this.$store.commit('PostEditor/SET_SELECTED_COMMENT_ITEM', this.item)
    },
    postedCommentAction (state) {
      this.itemComments = state.PostEditor.post.items.find(
        (item) => item.uuid === this.item.uuid
      ).itemComments
      this.onDisplay()
    }
  }
}
</script>

<style scoped></style>
